var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightSnow01 = function SvgLightSnow01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 44.93,
    y1: 205.46,
    x2: 203.05,
    y2: 62.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12.53,
    y1: 169.56,
    x2: 170.65,
    y2: 26.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 56.75,
    y1: 218.56,
    x2: 214.87,
    y2: 75.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 57.83,
    y1: 219.76,
    x2: 215.95,
    y2: 77.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 76.47,
    y1: 240.42,
    x2: 234.59,
    y2: 97.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 74.77,
    y1: 238.53,
    x2: 232.89,
    y2: 95.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 33.23,
    y1: 192.5,
    x2: 191.35,
    y2: 49.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 41.61,
    y1: 201.78,
    x2: 199.73,
    y2: 59.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 20.16,
    y1: 178.01,
    x2: 178.27,
    y2: 35.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.96,
    y1: 157.85,
    x2: 160.08,
    y2: 15.17,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M143.28,125.24c-.61-1.07-1.98-1.43-3.05-.82l-6.2,3.58,1.3-4.85c.32-1.19-.39-2.41-1.58-2.73-1.19-.3-2.41.39-2.73,1.58l-2.45,9.16-4.77,2.75c-1.22-1.27-2.78-2.19-4.54-2.62v-5.42l6.7-6.7c.87-.87.87-2.28,0-3.15s-2.28-.87-3.15,0l-3.55,3.55v-7.25c0-1.23-1-2.23-2.23-2.23s-2.23,1-2.23,2.23v7.24l-3.55-3.55c-.87-.87-2.28-.87-3.15,0-.87.87-.87,2.28,0,3.15l6.7,6.7v5.43c-1.76.43-3.33,1.35-4.55,2.62l-4.69-2.71-2.45-9.16c-.32-1.19-1.54-1.89-2.73-1.58-1.19.32-1.89,1.54-1.58,2.73l1.3,4.85-6.28-3.63c-1.06-.62-2.43-.25-3.05.82-.62,1.07-.25,2.43.82,3.05l6.27,3.62-4.85,1.3c-1.19.32-1.89,1.54-1.58,2.73.27,1,1.17,1.65,2.15,1.65.19,0,.38-.02.58-.08l9.15-2.45,4.72,2.72c-.25.84-.42,1.71-.42,2.62s.17,1.77.41,2.61l-4.7,2.72-9.16-2.45c-1.19-.3-2.41.39-2.73,1.58-.32,1.19.39,2.41,1.58,2.73l4.85,1.3-6.28,3.63c-1.07.62-1.43,1.98-.82,3.05.62,1.07,1.98,1.43,3.05.82l6.27-3.62-1.3,4.85c-.32,1.19.39,2.41,1.58,2.73,1.22.32,2.42-.41,2.73-1.58l2.45-9.16,4.69-2.71c1.22,1.27,2.79,2.19,4.55,2.62v5.5l-6.7,6.7c-.87.87-.87,2.28,0,3.15.87.87,2.28.87,3.15,0l3.55-3.55v7.17c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.16l3.55,3.55c.87.87,2.28.87,3.15,0,.87-.87.87-2.28,0-3.15l-6.7-6.7v-5.51c1.76-.43,3.33-1.35,4.55-2.62l4.75,2.74,2.45,9.16c.31,1.16,1.51,1.9,2.73,1.58,1.19-.32,1.89-1.54,1.58-2.73l-1.3-4.85,6.21,3.59c1.06.62,2.43.25,3.05-.82.62-1.07.25-2.43-.82-3.05l-6.2-3.58,4.85-1.3c1.19-.32,1.89-1.54,1.58-2.73s-1.54-1.89-2.73-1.58l-9.16,2.45-4.78-2.76c.24-.83.41-1.7.41-2.61s-.17-1.78-.42-2.62l4.78-2.76,9.16,2.45c.19.05.39.08.58.08.98,0,1.89-.66,2.15-1.65.32-1.19-.39-2.41-1.58-2.73l-4.85-1.3,6.21-3.59c1.07-.62,1.43-1.98.82-3.05M117.02,145.34c-2.72,0-4.93-2.21-4.93-4.94s2.21-4.95,4.93-4.95,4.95,2.22,4.95,4.95-2.22,4.94-4.95,4.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.82,116.53c-2.61-2.61-6.86-2.61-9.46,0l-7.21,7.21c-2.61,2.61-2.62,6.85,0,9.46l7.19,7.19c2.61,2.61,6.85,2.61,9.46,0l7.21-7.21c2.61-2.61,2.61-6.85,0-9.46l-7.19-7.19ZM66.86,130.03l-7.21,7.21c-.87.87-2.28.87-3.15,0l-7.19-7.19c-.87-.87-.87-2.28,0-3.15l7.21-7.21c.87-.87,2.28-.87,3.15,0l7.19,7.19c.87.87.87,2.28,0,3.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.45,174.18c-2.61-2.61-6.85-2.61-9.46,0l-7.21,7.21c-2.61,2.61-2.61,6.85,0,9.46l7.19,7.19c2.61,2.61,6.85,2.61,9.46,0l7.21-7.21h0c2.61-2.61,2.61-6.85,0-9.46l-7.19-7.19ZM101.49,187.68l-7.21,7.21c-.87.87-2.29.87-3.16,0l-7.19-7.19c-.87-.87-.87-2.28,0-3.15l7.21-7.21c.87-.87,2.28-.87,3.15,0l7.19,7.19c.87.87.87,2.28,0,3.15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.81,125.15c-1.23,0-2.23,1-2.23,2.23v7.94c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.94c0-1.23-1-2.23-2.23-2.23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.21,155.95c-1.23,0-2.23,1-2.23,2.23v7.94c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.94c0-1.23-1-2.23-2.23-2.23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M137.27,175.94c-1.23,0-2.23,1-2.23,2.23v7.94c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.94c0-1.23-1-2.23-2.23-2.23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.42,149.13c-1.23,0-2.23,1-2.23,2.23v7.94c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.94c0-1.23-1-2.23-2.23-2.23"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.62,184.75c-1.23,0-2.23,1-2.23,2.23v7.94c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.94c0-1.23-1-2.23-2.23-2.23"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.79,156.8c-1.23,0-2.23,1-2.23,2.23v7.94c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.94c0-1.23-1-2.23-2.23-2.23"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.95,25.93c-2.88,0-5.83.39-8.94,1.19C130.4,10.54,114.14,0,95.78,0,75.45,0,57.63,13.01,51.43,32.38c-.56,1.75.4,3.63,2.16,4.19,1.76.57,3.63-.4,4.18-2.16,5.31-16.6,20.59-27.75,38.01-27.75,15.48,0,29.22,8.77,35.86,22.61-4.57,2.09-7.73,5.17-9.67,7.64-1.14,1.44-.89,3.54.55,4.68.61.48,1.34.71,2.06.71.98,0,1.96-.44,2.62-1.27,1.8-2.29,4.96-5.3,9.8-6.69.02,0,.09-.03.11-.03,3.55-1.16,6.76-1.72,9.83-1.72,17.59,0,31.9,14.31,31.9,31.9s-14.31,31.9-31.9,31.9H45.18c-13.25,0-24.03-10.78-24.03-24.03s10.78-24.03,24.03-24.03c1.96,0,4,.32,6.43,1,3.19.96,6.14,2.69,8.33,4.86.65.65,1.5.97,2.35.97s1.71-.33,2.36-.98c1.3-1.3,1.29-3.41-.01-4.71-2.95-2.94-6.91-5.25-11.13-6.52-.01,0-.02,0-.03,0,0,0-.02-.01-.03-.01-3.05-.86-5.68-1.26-8.27-1.26-16.92,0-30.69,13.77-30.69,30.69s13.77,30.69,30.69,30.69h101.76c21.26,0,38.56-17.3,38.56-38.56,0-21.26-17.3-38.56-38.56-38.56"
  })));
};
export default SvgLightSnow01;